export const order = {
  ALL: 'Tout',

  // Experience
  JOB: 'Emplois',

  // Publications
  COURSE: 'Cours',
  EXAM: 'Examens',
  DEGREE: 'Diplômes',

  // Projects
  WEB: 'Sites Web',
  MOBILE: 'Applications Mobiles',
  PERSONAL_PROJECTS: 'Projets Personnels',

  // Certificates
  THESIS: 'Thèse',
  JOURNAL: 'Journal',
  CONFERENCE: 'Conférence',

  // Skills
  CURRENT: 'Utilise actuellement',
  PAST_FREQUENTLY: 'Utilisait fréquemment dans le passé',
  PAST_OCCASIONALLY: 'Connaît quelques notions',
};
